(() => {
  const initialize = (root) => {
    if (!matchMedia('(min-width: 750px)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.ccb').forEach((banner) => {
      const image = banner.querySelector('.ccb__left-image');
      if (!image || banner.dataset.ccbInitialized) return;
      banner.dataset.ccbInitialized = 'true';
      banner.classList.add('ccb--entering');
      image.decode().catch(() => {}).then(() => {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          setTimeout(() => banner.classList.remove('ccb--entering'), 180);
        }));
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
